/** Encode a value for a single URL path segment. */
export const encodeRouteParam = (value) => encodeURIComponent(String(value ?? ''));

/**
 * Decode a route param from useParams.
 * React Router already decodes once; a second decodeURIComponent throws on literal % (e.g. "2% jelly").
 */
export const decodeRouteParam = (value) => {
  if (value == null || value === '') return '';
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};
